import { useState } from "react";
import { Container, Navbar, Nav, Button } from "react-bootstrap";
import { Calendar, Menu, X } from "lucide-react";
import ThemeSwitcher from "./ThemeSwitcher";

const Header = () => {
  const [expanded, setExpanded] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setExpanded(false);
    }
  };

  return (
    <Navbar 
      expand="md" 
      fixed="top" 
      className="navbar-custom py-3"
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <Navbar.Brand href="#" className="d-flex align-items-center gap-2">
          <div className="icon-box-sm gradient-primary d-flex align-items-center justify-content-center shadow-soft">
            <Calendar size={18} color="white" />
          </div>
          <span className="fw-bold fs-5">AgendaFácil</span>
        </Navbar.Brand>

        <div className="d-flex align-items-center gap-2">
          <ThemeSwitcher />
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            {expanded ? <X size={24} /> : <Menu size={24} />}
          </Navbar.Toggle>
        </div>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link onClick={() => scrollToSection("servicos")}>
              Serviços
            </Nav.Link>
            <Nav.Link onClick={() => scrollToSection("galeria")}>
              Galeria
            </Nav.Link>
            <Nav.Link onClick={() => scrollToSection("sobre")}>
              Sobre
            </Nav.Link>
            <Nav.Link onClick={() => scrollToSection("contato")}>
              Contato
            </Nav.Link>
          </Nav>
          <Button 
            className="btn-primary-custom"
            onClick={() => scrollToSection("agendamento")}
          >
            Agendar Agora
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;